export const qualityScorePopupStyle = () => ({
  '.quality-score-popup': {
    maxWidth: '350px',
    width: '350px',

    '& .qs-Poor': {
      color: '#A80000',
    },
    '& .qs-Good': {
      color: '#107C10',
    },
    '& .qs-Values': {
      width: '100%',
      marginBottom: 10,

      '& td:first-child': {
        paddingLeft: 0,
      },
      '& tr': {
        height: '25px',
      },
      '& td': {
        borderBottom: '1px solid #EDEBE9',
      },
    },

  },
});
